import WizardLayout from './WizardLayout';
import type { WizardLayoutProps } from '../types/purchaseTypes';

function Wizard({ variant, validation, progressBar }: WizardLayoutProps) {
  return (
    <WizardLayout
      variant={variant}
      validation={validation}
      progressBar={progressBar}
    />
  );
};



export default Wizard;
